module.exports = __webpack_public_path__ + "img/newt2.7e69c9f9.png";